import NoDataIllustration from '../../../../illustrations/no-data.svg';
import * as React from 'react';

export default class InvalidData extends React.Component {
  render() {
    const { message = 'There is no data', hint } = this.props;

    return (
      <div className="no-data-state">
        <img src={NoDataIllustration} alt="No data" />
        <h2>{message}</h2>
        {hint ? <p>{hint}</p> : null}
      </div>
    );
  }
}
